var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlasses(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "31mm",
    height: 41.537,
    viewBox: "0 0 31 10.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -286.01)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    stroke: "none",
    transform: "matrix(.98303 0 0 .98303 -57.737 129.76)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#513a26",
    fillOpacity: 0.873,
    strokeWidth: 0.066,
    d: "M62.015 168.29c-.586-1.43-1.77-6.939-1.196-7.366 1.35-1.006 11.25-1.424 11.606.633.354 2.057-.353 5.928-1.707 7.216-1.354 1.287-8.203.734-8.703-.483z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#513a26",
    fillOpacity: 0.873,
    strokeWidth: 0.066,
    d: "M86.76 168.592c.587-1.43 1.771-6.938 1.197-7.366-1.35-1.005-11.25-1.423-11.606.634-.354 2.057.353 5.928 1.707 7.215s8.203.735 8.703-.483z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    strokeWidth: 0.061,
    d: "M86.828 168.2c-.464 1.132-6.832 1.645-8.091.449-1.26-1.197-1.917-4.796-1.587-6.709.33-1.913 9.536-1.524 10.79-.589.535.397-.566 5.52-1.112 6.849m-24.653 0c-.546-1.33-1.646-6.452-1.113-6.849 1.256-.935 10.461-1.324 10.791.589.33 1.913-.328 5.512-1.587 6.709-1.259 1.196-7.627.683-8.091-.45zm20.228-9.231c-3.598.1-5.806 1.685-7.803 1.913l-.186.001c-2-.225-4.21-1.813-7.814-1.914-1.899-.054-4.687-.082-7.866.898.039.498.363 2.482.363 2.482s.252-.012.562.122c.31.132.807 3.034 1.28 4.747.472 1.713.77 2.865 5.242 2.907 4.472.042 4.946-.495 5.553-1.963.676-1.637 1.076-4.902 2.7-5.004h.132c1.627.099 2.027 3.366 2.703 5.004.606 1.468 1.081 2.005 5.553 1.963 4.472-.042 4.77-1.194 5.242-2.907.473-1.713.97-4.615 1.28-4.747.31-.133.562-.122.562-.122s.324-1.984.363-2.482c-3.18-.98-5.967-.952-7.866-.898"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlasses);
export default __webpack_public_path__ + "static/media/glasses.91b3144034f71455f6836f62b6f07f71.svg";
export { ForwardRef as ReactComponent };